import { renderTimeViewClock, TimePicker, TimePickerProps } from '@mui/x-date-pickers';
import StyledLabel from 'components/general/StyledLabel';
import type { IGenericObject } from 'components/general/types';
import { useFormik } from 'formik';
import { makeGuidance, useInReadOnlyBranch } from 'hooks';
import _ from 'lodash';
import type { Moment } from 'moment-timezone';
import useStyles from '../styles';

interface IProps extends TimePickerProps<Moment | null> {
  name: string;
  label: string;
  errors?: IGenericObject;
  disabled?: boolean;
  optional?: boolean;
  guide?: ReturnType<ReturnType<typeof makeGuidance>>['guide'] | null;
  setFieldValue?: ReturnType<typeof useFormik>['setFieldValue'];
  [key: string]: unknown;
}

const LabeledTimePicker = (props: IProps) => {
  const {
    name,
    label,
    errors,
    disabled,
    optional,
    guide,
    setFieldValue,
    onBlur, // These are only here to remove them from `remainingProps`
    onChange, // These are only here to remove them from `remainingProps`
    ...remainingProps
  } = props;
  const inReadOnlyBranch = useInReadOnlyBranch();

  const { classes } = useStyles({
    error: Boolean(errors && _.get(errors, name)),
  });

  return (
    <>
      <StyledLabel>{optional ? `${label} (optional)` : label}</StyledLabel>
      <br />
      <TimePicker
        ampm={false}
        slotProps={{
          textField: {
            fullWidth: true,
            className: classes.root,
          },
        }}
        onOpen={guide ? () => guide(undefined, name, label) : undefined}
        onClose={guide ? () => guide() : undefined}
        onChange={(value) => {
          if (value && setFieldValue) {
            setFieldValue(name, value);
          }
        }}
        views={['hours', 'minutes', 'seconds']}
        viewRenderers={{
          hours: renderTimeViewClock,
          minutes: renderTimeViewClock,
          seconds: renderTimeViewClock,
        }}
        disabled={disabled || inReadOnlyBranch}
        {...remainingProps}
      />
    </>
  );
};

export default LabeledTimePicker;
